export default __webpack_public_path__ + "img/e882eda5a14c0ea36b2ebae78fabbf2a.png";